module.exports = __webpack_public_path__ + "img/factory-3.eb1c2b71.jpg";